module.exports = __webpack_public_path__ + "img/home_slide3.91e48dd3.jpg";